import { render, staticRenderFns } from "./BasicDialog.vue?vue&type=template&id=0d645518&scoped=true&"
import script from "./BasicDialog.vue?vue&type=script&lang=js&"
export * from "./BasicDialog.vue?vue&type=script&lang=js&"
import style0 from "./BasicDialog.vue?vue&type=style&index=0&id=0d645518&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d645518",
  null
  
)

export default component.exports